export const OutreachController = {
    index(): void {},
};
